import { render } from "./LoginText.vue?vue&type=template&id=d7333882"
import script from "./LoginText.vue?vue&type=script&lang=js"
export * from "./LoginText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__